export const environment = {
  baseUrl: 'https://quiz.qa.aodocs.app',
  apiUrl: '/_ah/api/',
  aodocsUrl: 'https://ao-docs.appspot.com/',
  clientId: '539948003142-gv22hi6g81qgtvl9r6tef4s3du6bljev.apps.googleusercontent.com',
  version: '1.0.0',
  production: true
};
